import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Globe2, Building2 } from "lucide-react";

export default function Enterprise() {
  return (
    <section id="enterprise" className="py-24 md:py-32 bg-slate-50 border-y border-slate-200" data-testid="enterprise-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-0 lg:grid-cols-2 border border-slate-200 bg-white overflow-hidden">
          <motion.div
            initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="p-10 md:p-14 flex flex-col justify-center">
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-ember">Enterprise Solutions</p>
            <h2 className="mt-4 font-heading font-bold tracking-tight text-ink text-3xl sm:text-4xl">
              Holistic growth environments for enterprise partners.
            </h2>
            <p className="mt-5 text-lg text-slatey leading-relaxed">
              From global LED wall installations to high-level strategic marketing consultancy, On The Brink delivers
              holistic growth environments for enterprise partners.
            </p>

            <div className="mt-8 flex items-center gap-4">
              <div className="flex h-14 items-center justify-center border border-slate-200 bg-slate-50 px-6 font-heading font-extrabold text-ink text-xl tracking-tight"
                   data-testid="enterprise-client-logo">
                AECOM
              </div>
              <span className="text-sm text-slatey">Trusted by global enterprise teams.</span>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <Globe2 className="h-5 w-5 text-ember mt-0.5" />
                <div><div className="font-semibold text-ink text-sm">Global Installs</div><div className="text-xs text-slatey">LED walls at scale</div></div>
              </div>
              <div className="flex items-start gap-3">
                <Building2 className="h-5 w-5 text-ember mt-0.5" />
                <div><div className="font-semibold text-ink text-sm">Strategic Consultancy</div><div className="text-xs text-slatey">Commercial growth</div></div>
              </div>
            </div>

            <Link to="/contact" data-testid="enterprise-cta"
                  className="mt-9 inline-flex items-center gap-2 bg-ink text-white px-7 py-4 text-sm font-semibold hover:bg-ink-soft transition-colors w-fit">
              Talk to Our Enterprise Team <ArrowRight className="h-4 w-4" />
            </Link>
          </motion.div>

          <div className="relative min-h-[320px] lg:min-h-full">
            <img
              src="https://images.unsplash.com/photo-1771147372627-7fffe86cf00b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="Enterprise environment" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
